import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-calendar-icon',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    standalone: false
})
export class CalendarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
